import React from 'react';
import { observer } from 'mobx-react';
import { Surface } from '@infoods/lifebase-ui';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';

import classes from './BestSellingWidget.module.scss';
import { BestSellingResponse } from '../../../interfaces/entity-dashboard/BestSellingResponse';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { SellingInfo } from './SellingInfo/SellingInfo';
import { useBestSellingData } from './hooks/useBestSellingData';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';
import { WidgetEmptyPlaceholder } from '../../../../shared/components/ui-components';
import { calcSellingProgressValue } from './utils';
import { isEmptyArray } from '../../../../shared/utils/jsUtils';

const renderSellingList = (data: BestSellingResponse) => {
  const topItem = data.find(({ position }) => position === 1);

  if (!topItem) return;

  return (
    <div className={classes.sellingContainer}>
      {data.map((item) => {
        const { itemId, position, itemName, revenue } = item;
        const isFulfilled = position === 1 && revenue.diffPercent > 0;

        return (
          <SellingInfo
            key={itemId}
            name={`${position}.${itemName}`}
            value={calcSellingProgressValue(item, topItem)}
            totalAmount={revenue.value}
            percentDiff={revenue.diffPercent}
            isFulfilled={isFulfilled}
          />
        );
      })}
    </div>
  );
};

const BestSellingWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;
  const { bestSellingData } = useBestSellingData({
    dateRangePreset,
    solutionTypeFilter,
    itemCount: 5,
  });

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Best Selling Services & Subscriptions"
        tooltipContent={
          <>
            Top ScanIQ + nutrition subscriptions
            <br />
            Requires Stripe billing
          </>
        }
      />
      {!isEmptyArray(bestSellingData) ? (
        renderSellingList(bestSellingData)
      ) : (
        <WidgetEmptyPlaceholder
          title="No data yet"
          icon={<BarChartRoundedIcon />}
          text={
            <>
              Data will appear here as activity
              <br />
              becomes available
            </>
          }
        />
      )}
    </Surface>
  );
});

export { BestSellingWidget };
